import React from 'react';
import { Dispatch, SetStateAction } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
	faPause, 
	faCaretRight, 
	faCaretLeft, 
	faAngleLeft,
	faAngleRight, 
	faBackwardFast,
	faForwardFast
} from '@fortawesome/free-solid-svg-icons';

import { getNewXIndex } from './Common';
import './ControlPanel.css';

type ControlPanelProps = {
	xIndex: number, 
	xIndexMax: number,
	setXIndex: Dispatch<SetStateAction<number>>,
	allowLooping: boolean,
	playingState: number, 
	setPlayingState: Dispatch<SetStateAction<number>>, 
	screenSize: string,
	currentDate: Date,
	currentWeight: number,
	currentNotes: string
};

let dateFormatter = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

function ControlPanel( {
	xIndex, 
	xIndexMax,
	setXIndex, 
	allowLooping,
	playingState, 
	setPlayingState, 
	screenSize,
	currentDate, 
	currentWeight,
	currentNotes
}: ControlPanelProps) {
 // let playPrev = useRef<HTMLButtonElement>(null);
	//let playNext = useRef<HTMLButtonElement>(null);

	function handlePlayStateUpdate( step:number ) {
		if(playingState === step) {
			setPlayingState(0);
		}
		if(playingState === 0 || playingState === -step) {
			setPlayingState(step);
		}
	}
	
	return (
		<div>
		<div className="controlsContainer">
	      		<div>
		      		<button aria-label="Go to Start" type="button" onClick={() => {
								setXIndex(0)
							}}>
	        			<FontAwesomeIcon icon={faBackwardFast} />
	      			</button>
							<button aria-label="Play Backwards" type="button" onClick={() => {
								handlePlayStateUpdate(-1);
								}
							}>
								{ 
									playingState === -1 ? 
										<FontAwesomeIcon icon={faPause} /> 
										:
										<FontAwesomeIcon icon={faCaretLeft} /> 
								}
		      		</button>
		      		<button aria-label="Previous Day" type="button" onClick={() => {
								setXIndex( xIndex => getNewXIndex(xIndex, -1, xIndexMax, allowLooping))
							}}>
	        			{screenSize === 'sm' ? <FontAwesomeIcon icon={faAngleLeft} /> : "Prev. Day" }
	      			</button>
						</div>
						<span className="currentDate">{dateFormatter.format(currentDate)}</span>
						<div>
			      	<button aria-label="Next Day" type="button" onClick={() => {
								setXIndex( xIndex => getNewXIndex(xIndex, 1, xIndexMax, allowLooping))
							}}>
			        	{screenSize === 'sm' ? <FontAwesomeIcon icon={faAngleRight} /> : "Next Day" }
		      		</button>
							<button aria-label="Play Forward" type="button" onClick={() => {
								handlePlayStateUpdate(1);
							}}>
								{	
									playingState === 1 ? 
										<FontAwesomeIcon icon={faPause} /> 
										:
										<FontAwesomeIcon icon={faCaretRight} /> 
								}
		  	    	</button>
		      		<button aria-label="Go to End" type="button" onClick={() => {
								setXIndex(xIndexMax-1)
							}}>
	        			<FontAwesomeIcon icon={faForwardFast} />
	      			</button>
						</div>
	      	</div>
	      	<div className="primaryInfoLine">
						<span className="weightInfo">Weight: {currentWeight.toFixed(1)} lbs</span>
						<span className="deltaInfo">-{Math.abs(currentWeight-208.6).toFixed(1)} from start</span>
						<span className="cheatDayInfo">{currentNotes}</span>
					</div>
		</div>
  );
}

export default ControlPanel;
